import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { updateStudent } from "../../../store/studentsSlice";
import { getUserById } from "../../../api/usersService";
import useDistricts from "../../../hooks/useDistricts";
import { activePolygonNames } from "../../../utils/districts";

/**
 * Poligonul elevului (ADMIN/MANAGER). Contează doar când sunt mai multe
 * poligoane: elevul alege o dată la prima programare, personalul îl poate
 * schimba aici; gol = elevul alege din nou la următoarea programare.
 * Se salvează imediat, separat de restul formularului.
 */
export default function StudentPolygonField({ studentId, value, onSaved }) {
   const dispatch = useDispatch();
   const districts = useDistricts();
   const polygons = activePolygonNames(districts);
   const [current, setCurrent] = useState(value || "");
   const [busy, setBusy] = useState(false);
   const [error, setError] = useState("");

   const multiple = polygons.length >= 2;

   useEffect(() => {
      setCurrent(value || "");
   }, [value]);

   // lista elevilor nu aduce mereu câmpul: îl citim din profilul elevului
   useEffect(() => {
      if (!multiple || !studentId) return undefined;
      let alive = true;
      getUserById(studentId)
         .then((user) => {
            if (alive) setCurrent(user?.polygonDistrict || "");
         })
         .catch(() => {});
      return () => {
         alive = false;
      };
   }, [multiple, studentId]);

   if (!studentId || !multiple) return null;

   const save = async (next) => {
      const previous = current;
      setCurrent(next);
      setBusy(true);
      setError("");
      try {
         const updated = await dispatch(
            updateStudent({ id: studentId, data: { polygonDistrict: next || null } }),
         ).unwrap();
         const saved = updated?.polygonDistrict ?? (next || null);
         setCurrent(saved || "");
         if (typeof onSaved === "function") onSaved(saved);
      } catch (err) {
         setCurrent(previous);
         setError(err?.message || "Nu am putut salva poligonul.");
      } finally {
         setBusy(false);
      }
   };

   return (
      <label className="studentsProfileUI__field">
         <span className="studentsProfileUI__fieldLabel">Poligon</span>
         <select
            value={current}
            onChange={(e) => save(e.target.value)}
            className="studentsProfileUI__select"
            disabled={busy}
         >
            <option value="">Alege la programare</option>
            {polygons.map((name) => (
               <option key={name} value={name}>
                  {name}
               </option>
            ))}
            {current && !polygons.includes(current) ? (
               <option value={current}>{current} (inactiv)</option>
            ) : null}
         </select>
         {error ? (
            <span className="studentsProfileUI__fieldError">{error}</span>
         ) : null}
      </label>
   );
}
